import React from 'react'
import SuccessStoriesHero from './section/SuccessStoriesHero.js'
import Success from './section/Success.js'

const SuccessStories = () => {
  return (
    <>
    <SuccessStoriesHero/>
    <Success/>
    </>
  )
}

export default SuccessStories